import { useMemo } from 'react';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IRouterProps } from '@interfaces/App.interface';
import { TInheritedProps, generateGlobalColumns, generateBasicColumn, generateColorColumn, IDataGridConfig } from '@ts/storybook';
import { IConfigComponent, CLabel } from '@ts/ui-models';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';

interface ILabelsProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'labels',
  aclId: 'tag',
  entity: 'label',
  fetchURL: '/api/tags',
  crudURL: '/api/tag',
  mainClass: CLabel,
};

const Labels = (props: ILabelsProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };
  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      globalCells.name(),
      generateBasicColumn({ field: 'restrictedToEntities', headerName: 'Restricted to' }, { field: 'restrictedToEntities' }),
      generateColorColumn({ field: 'color' }, { field: 'color', mainClass: CLabel }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      customDeleteModal={{ message: 'This will also erase associations related to the item' }}
      inheritedProps={inheritedProps}
    />
  );
};

export default Labels;
